"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _lodash = _interopRequireDefault(require("lodash.isempty")),
    _classnames = _interopRequireDefault(require("classnames")),
    OrgCreditBanner = function OrgCreditBanner(props) {
  var orgCreditInfo = props.orgCreditInfo;
  if ((0, _lodash["default"])(orgCreditInfo)) return null;
  var _orgCreditInfo$packag = orgCreditInfo["package"];
  _orgCreditInfo$packag = void 0 === _orgCreditInfo$packag ? {} : _orgCreditInfo$packag;
  var videoQuantity = _orgCreditInfo$packag.videoQuantity,
      _orgCreditInfo$credit = orgCreditInfo.creditBalance;
  _orgCreditInfo$credit = void 0 === _orgCreditInfo$credit ? {} : _orgCreditInfo$credit;
  var balance = _orgCreditInfo$credit.balance,
      rolloverBalance = _orgCreditInfo$credit.rolloverBalance,
      totalBalance = balance + rolloverBalance;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    className: "payment-options__body__credit-org__header"
  }, "AVAILABLE CREDITS"), _react["default"].createElement("div", {
    className: (0, _classnames["default"])("payment-options__body__credit-org__banner", {
      "no-credit": 0 === totalBalance
    })
  }, _react["default"].createElement(_uiKit.Icon, {
    name: "video",
    size: 25,
    color: "white"
  }), _react["default"].createElement("span", {
    className: "payment-options__body__credit-org__banner__text"
  }, "You have", _react["default"].createElement("b", null, " ".concat(-1 === videoQuantity ? "Unlimited" : totalBalance, " Video Credits ")), -1 === videoQuantity ? "" : "remaining")));
},
    _default = OrgCreditBanner;

exports["default"] = _default;